export function mapByField<T, V extends keyof T>(field: V, items?: T[] | null): Map<T[V], T> {
  return new Map(items?.map((item) => [item[field], item]));
}
